import { RepeatIcon } from './RepeatIcon';

/**
 * author: Google
 * id 9AEE0CB7-46B9-414F-A8A8-AFB127CB7057
 * name repeat
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/repeat.svg
 * tags
 * - Arrow 
 */
export const RepostIcon = RepeatIcon;
export default RepostIcon